import React from "react";

const COPY_LINK_BASE = "tw-inline-flex tw-items-center tw-justify-center tw-w-[34px] tw-h-[34px] tw-rounded-[var(--cf-radius-sm)] tw-border-0 tw-bg-transparent tw-text-[color:var(--cf-color-text-muted)] tw-transition-[opacity,background-color,color] tw-duration-150 hover:tw-bg-[color:var(--cf-color-surface-neutral)] hover:tw-text-[color:var(--cf-color-accent)] focus:tw-bg-[color:var(--cf-color-surface-neutral)] focus:tw-text-[color:var(--cf-color-accent)] focus:tw-outline-none focus:tw-opacity-100 focus:tw-pointer-events-auto group-hover:tw-opacity-100 group-hover:tw-pointer-events-auto";
const COPY_LINK_IDLE = "tw-opacity-0 tw-pointer-events-none";
const COPY_LINK_COPIED = "tw-opacity-100 tw-pointer-events-auto tw-bg-[color:var(--cf-color-surface-neutral)] !tw-text-[color:var(--cf-color-accent)]";

const PageArticle = ({
    page,
    normalizedHtml,
    linkCopied,
    onCopyCurrentUrl,
    contentRef
}) => (
    <article className="confluence-page tw-mx-auto">
        <div className="tw-mb-7">
            <div className="confluence-page__title-row tw-group tw-flex tw-items-center tw-gap-3">
                <h1 className="confluence-page__title tw-m-0 tw-py-4 tw-text-[color:var(--cf-color-text-heading)] tw-leading-[1.16]">
                    {page.title}
                </h1>
                <button
                    aria-label="Copy current page link"
                    className={`${COPY_LINK_BASE} ${linkCopied ? COPY_LINK_COPIED : COPY_LINK_IDLE}`}
                    onClick={onCopyCurrentUrl}
                    title={linkCopied ? "Kopiert" : "Link kopieren"}
                    type="button"
                >
                    <span className={`fa ${linkCopied ? "fa-check" : "fa-link"}`} />
                </button>
            </div>
        </div>
        <div
            className="confluence-page__body"
            dangerouslySetInnerHTML={{ __html: normalizedHtml }}
            ref={contentRef}
        />
    </article>
);

export default PageArticle;
